import * as types from './upload.actionTypes';

export default {
  setAnexos: data => ({
    type: types.SET_ANEXOS,
    payload: data,
  }),
  setAnexosSaga: data => ({
    type: types.SET_ANEXOS_SAGA,
    payload: data,
  }),
  setAnexosCustomizado: data => ({
    type: types.SET_ANEXOS_CUSTOMIZADOS,
    payload: data,
  }),
  setAnexosCustomizadoSaga: data => ({
    type: types.SET_ANEXOS_CUSTOMIZADOS_SAGA,
    payload: data,
  }),
  changeAnexo: data => ({
    type: types.CHANGE_ANEXO,
    payload: data,
  }),
  deleteAnexo: data => ({
    type: types.DELETE_ANEXO,
    payload: data,
  }),
  addAnexoCustomizado: () => ({
    type: types.ADD_ANEXO_CUSTOMIZADO,
  }),
  changeTextAnexo: data => ({
    type: types.CHANGE_TEXT_ANEXO,
    payload: data,
  }),
  resetAnexos: () => ({
    type: types.RESET,
  }),
};
